import { Fragment } from 'react';

import { PagePagination } from '@playbooks/molecules/paginations/page-pagination';
import { toNumber } from '@playbooks/utils';

const BasicPagination = ({ meta, params, setParams }) => (
	<Fragment>
		<PagePagination meta={meta} params={params} setParams={setParams} />
		<small className='whitespace-nowrap text-sm font-light text-foreground-body'>
			{toNumber(meta.totalRecords)} records
		</small>
	</Fragment>
);
export { BasicPagination };
